import { render, staticRenderFns } from "./AnaliseProdutoFatGrupoProdutos.vue?vue&type=template&id=65125aa0&scoped=true&"
import script from "./AnaliseProdutoFatGrupoProdutos.vue?vue&type=script&lang=js&"
export * from "./AnaliseProdutoFatGrupoProdutos.vue?vue&type=script&lang=js&"
import style0 from "./AnaliseProdutoFatGrupoProdutos.vue?vue&type=style&index=0&id=65125aa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65125aa0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
